import React, { useCallback } from 'react';
import { KnightKey, ContextMenuData } from '../../../types';
import PlaceholderPortrait from '../../ui/PlaceholderPortrait';

interface KnightItemProps {
  knight: KnightKey;
  index: number;
  contextMenu: ContextMenuData | null;
  closeContextMenu?: () => void;
  onKnightSelect: (k: KnightKey) => void;
  handleContextMenu?: (e: React.MouseEvent, target: string, type: ContextMenuData['type'], options?: string[]) => void;
}

const KnightItem = React.memo(({ 
  knight, 
  index, 
  contextMenu, 
  closeContextMenu, 
  onKnightSelect, 
  handleContextMenu 
}: KnightItemProps) => {
  const handleClick = useCallback(() => {
    if (contextMenu && closeContextMenu) {
      closeContextMenu();
    } else {
      onKnightSelect(knight);
    }
  }, [contextMenu, closeContextMenu, onKnightSelect, knight]);

  const handleContext = useCallback((e: React.MouseEvent) => {
    if (handleContextMenu) {
      if (contextMenu && closeContextMenu) closeContextMenu();
      handleContextMenu(e, knight, 'knight', ['select-compendium']);
    }
  }, [contextMenu, closeContextMenu, handleContextMenu, knight]);

  return (
    <div
      id={`char-portrait-${index + 1}`}
      className={`interactive-element ${contextMenu ? 'no-hover' : ''}`}
      style={{ pointerEvents: contextMenu ? 'none' : 'auto' }}
      onClick={handleClick}
      onContextMenu={handleContext}
    >
      <PlaceholderPortrait label="" />
    </div>
  );
});

export default KnightItem;
